import axios from "axios";
import { envConfig } from "@/config/env";
import service from "../service";

export default {
    /**
     * 上传安装包
     * POST /api/客户端版本管理/客户端安装包上传
     */
    uploadPackage(
        file: File,
        params: { version: string; type: string; remarks: string },
        onProgress?: (percent: number) => void
    ): Promise<any> {
        const fd = new FormData();
        fd.append("File", file);

        return service({
            method: "POST",
            url: "/客户端版本管理/客户端安装包上传",
            data: fd,
            params: {
                Version: params.version,
                type: params.type,
                Remarks: params.remarks,
            },
            timeout: 10 * 60 * 1000,
            onUploadProgress: (e: any) => {
                if (onProgress && e.total) {
                    onProgress(Math.round((e.loaded / e.total) * 100));
                }
            },
        });
    },

    /**
     * 列表查询
     * POST /api/客户端版本管理/列表查询
     */
    getVersionList(params?: {
        page?: number;
        key?: string;
        intPageSize?: number;
    }, data: any[] = []): Promise<any> {
        return service({
            method: "POST",
            url: "/客户端版本管理/列表查询",
            data,
            params: {
                page: params?.page || 1,
                key: params?.key || "",
                intPageSize: params?.intPageSize || 50,
            },
        });
    },

    /**
     * 获取安装包下载地址（拼接完整URL）
     */
    getDownloadUrl(fileName: string): string {
        const base = service.defaults.baseURL || "/api";
        return `${base}/客户端版本管理/客户端安装包下载?fileName=${encodeURIComponent(fileName)}`;
    },

    checkLatestVersionPublic(type: string): Promise<any> {
        return axios({
            method: "GET",
            baseURL: envConfig.apiBaseUrl,
            url: "/客户端版本管理/版本检查",
            params: {
                类型: type,
            },
        }).then(response => response.data);
    },

    getPublicDownloadUrl(fileName: string, baseUrl = envConfig.apiBaseUrl): string {
        return `${baseUrl.replace(/\/$/, "")}/客户端版本管理/客户端安装包下载?fileName=${encodeURIComponent(fileName)}`;
    },
};
